import 'rxjs'
import {ajax} from 'rxjs/observable/dom/ajax'
import config from '../config'
import {buildUserInfoPayload} from './CurrentUserInfoEpic'
import errorHandlerBuilder from './errorHandlerBuilder'
import {
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_ERROR,
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADED,
  ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING,
  EVENT_USER_CREATED,
  PATH_ENTERPRISE_ACCOUNT_ADD_USER
} from '../constants'

const api_server_host = config.api_server_host

const errorHandler = errorHandlerBuilder(ACTION_ENTERPRISE_ACCOUNT_ADD_USER_ERROR)

const epic = (action$, store) =>
  action$.ofType(ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADING)
    .mergeMap(action => {

      const tokenData = store.getState().user
      const token = tokenData.access_token
      const type = tokenData.token_type

      return ajax({
        method: 'POST',
        url: `${api_server_host}${PATH_ENTERPRISE_ACCOUNT_ADD_USER}`,
        headers: {
          Authorization: `${type} ${token}`,
          'Content-Type': 'application/json'
        },
        body: action.payload,
        responseType: 'json'
      }).map(data=> {
        const userInfo = data.response
        var payload = buildUserInfoPayload(userInfo)
        payload.message = 'New user is added to the enterprise account.'
        return {
          type: ACTION_ENTERPRISE_ACCOUNT_ADD_USER_LOADED, payload: payload
        }
      }).rxEmit(EVENT_USER_CREATED).catch(errorHandler)

    })
export default epic




// WEBPACK FOOTER //
// ./src/epics/EnterpriseAccountAddUserEpic.js